import React from "react";
import "styles/About.css";

const About=()=>{
  return (
    <div className="home-about">
      <div className="home-about-description ml-auto mr-auto">
        <h1>My, Myself & I </h1>
        <p className="home-about-body ml-auto mr-auto">
          I’m a Software Developer located in New Delhi. I am passionate about
          problem solving and building excellent software that improves the
          lives of the peoples. I like doing personal projects, which you will
          find in the project section of this website. My specialties can be
          found on the homepage, of which mostly comprises of Full Stack
          Developement and block chain developement.
          <br /> <br /> <br /> Apart from coding, some other activities that I
          love to do!
          <br />
          Playing Chess <br />
          Internet Surfing
          <br />
          Travelling <br />
        </p>
      </div>
    </div>
  );
}
export default About;
